import { environment } from "../config/environment";
import { customFetch } from "./Auth";

export const getOrgsDoctorsInfo = async (org, dateParam) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/orgs/public-info/${org}?date=${dateParam}`,
      {
        method: "GET",
        headers: { token: localStorage.token }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying doctors for org:", res.statusText);
      alert("Error querying doctors for org");
    }
  } catch (error) {
    console.error("Error querying doctors for org:", error);
  }
};

export const getUserFeedbackDashboard = async (startDate = "") => {
  try {
    const query = startDate
      ? `?startDate=${encodeURIComponent(startDate)}`
      : "";
    const res = await customFetch(
      `${environment.apiUrl}/orgs/user-feedback-dashboard${query}`,
      {
        method: "GET",
        headers: { token: localStorage.token },
      },
    );

    if (!res.ok) {
      throw new Error(`Failed to fetch VA user feedback: ${res.status}`);
    }

    const data = await res.json();
    return {
      feedback: Array.isArray(data.feedback) ? data.feedback : [],
      summary: data.summary || { totalRatings: 0, avgOverallRating: 0 },
      appliedEndDate: data.appliedEndDate,
    };
  } catch (error) {
    console.error("Error querying VA user feedback:", error);
    throw error;
  }
};